import React from "react";
import PrevArrowIcon from '../../icons/prevArrow'

const PrevArrow = (props) => {
    const {className, style, onClick} = props

    return (
        <div className={className} onClick={onClick} style={{...style}}>
            <PrevArrowIcon name="chevron-left" color="#999" size={40} />
        </div>
    )
}

export default PrevArrow